/* WordyBarks theme JS */
(function () {
  "use strict";
  var $ = function (s, c) { return (c || document).querySelector(s); };
  var $$ = function (s, c) { return Array.prototype.slice.call((c || document).querySelectorAll(s)); };

  /* ---------- Loader ---------- */
  var loader = $("#loader"), lfill = $("#lfill"), lcount = $("#lcount");
  function bootReveals() {
    var hdr = $("#hdr"); if (hdr) hdr.classList.add("in");
    $$(".hl").forEach(function (el, i) { setTimeout(function () { el.classList.add("in"); }, 150 + i * 120); });
    $$(".hrv").forEach(function (el, i) { setTimeout(function () { el.classList.add("in"); }, 450 + i * 120); });
    var bw = $("#boardwrap"); if (bw) setTimeout(function () { bw.classList.add("in"); }, 500);
    var tr = $("#trusted"); if (tr) setTimeout(function () { tr.classList.add("in"); }, 800);
    var wm = $("#wm"); if (wm) setTimeout(function () { wm.classList.add("in"); }, 900);
    var sb = $("#statusbar"); if (sb) setTimeout(function () { sb.classList.add("in"); }, 700);
  }
  if (loader && lfill && lcount) {
    var p = 0;
    var t = setInterval(function () {
      p = Math.min(100, p + Math.ceil(Math.random() * 22));
      lfill.style.width = p + "%";
      lcount.textContent = String(p).padStart(3, "0");
      if (p >= 100) {
        clearInterval(t);
        setTimeout(function () {
          loader.classList.add("exit");
          bootReveals();
          setTimeout(function () { loader.remove(); }, 750);
        }, 250);
      }
    }, 120);
  } else { bootReveals(); }

  /* ---------- Clock ---------- */
  var ct = $("#clock-t"), cd = $("#clock-d");
  if (ct && cd) {
    var tick = function () {
      var n = new Date();
      ct.textContent = n.toLocaleTimeString("en-US", { hour: "numeric", minute: "2-digit" }).toLowerCase();
      cd.textContent = n.toLocaleDateString("en-US", { day: "2-digit", month: "long", year: "numeric" });
    };
    tick(); setInterval(tick, 30000);
  }

  /* ---------- IntersectionObserver reveals ---------- */
  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (e) {
      if (e.isIntersecting) {
        var d = parseInt(e.target.getAttribute("data-d") || "0", 10);
        setTimeout(function () { e.target.classList.add("in"); }, d);
        io.unobserve(e.target);
      }
    });
  }, { threshold: 0.15 });
  $$(".io").forEach(function (el) { io.observe(el); });

  /* ---------- Nav menu ---------- */
  var menu = $("#navmenu"), openBtn = $("#openmenu"), closeBtn = $("#closemenu");
  function closeMenu() { if (!menu) return; menu.classList.remove("vis"); setTimeout(function () { menu.classList.remove("open"); }, 400); }
  if (openBtn && menu) openBtn.addEventListener("click", function () { menu.classList.add("open"); requestAnimationFrame(function () { requestAnimationFrame(function () { menu.classList.add("vis"); }); }); });
  if (closeBtn) closeBtn.addEventListener("click", closeMenu);
  $$("#navmenu [data-goto]").forEach(function (b) {
    b.addEventListener("click", function () {
      var id = b.getAttribute("data-goto"); closeMenu();
      var el = document.getElementById(id);
      if (el) setTimeout(function () { el.scrollIntoView({ behavior: "smooth" }); }, 420);
      else window.location.href = "/#" + id;
    });
  });

  /* ---------- Demo board ---------- */
  var bubble = $("#bubble"), audioCtx = null, bubbleTimer = null;
  function beep(f) {
    try {
      audioCtx = audioCtx || new (window.AudioContext || window.webkitAudioContext)();
      var o = audioCtx.createOscillator(), g = audioCtx.createGain();
      o.type = "sine"; o.frequency.value = f;
      g.gain.setValueAtTime(0.0001, audioCtx.currentTime);
      g.gain.exponentialRampToValueAtTime(0.18, audioCtx.currentTime + 0.02);
      g.gain.exponentialRampToValueAtTime(0.0001, audioCtx.currentTime + 0.28);
      o.connect(g); g.connect(audioCtx.destination);
      o.start(); o.stop(audioCtx.currentTime + 0.3);
    } catch (e) {}
  }
  $$(".dogbtn").forEach(function (b) {
    b.addEventListener("click", function () {
      beep(parseFloat(b.getAttribute("data-f") || "440"));
      if (bubble) {
        bubble.textContent = b.getAttribute("data-word") || "";
        bubble.classList.add("show");
        clearTimeout(bubbleTimer);
        bubbleTimer = setTimeout(function () { bubble.classList.remove("show"); }, 1400);
      }
    });
  });

  /* ---------- Stat counters ---------- */
  var sg = $("#statgrid");
  if (sg) {
    var cio = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (!e.isIntersecting) return;
        cio.unobserve(e.target);
        $$("[data-count]", e.target).forEach(function (n) {
          var target = parseInt(n.getAttribute("data-count"), 10), cur = 0;
          var step = Math.max(1, Math.round(target / 30));
          var iv = setInterval(function () {
            cur = Math.min(target, cur + step);
            n.textContent = cur;
            if (cur >= target) clearInterval(iv);
          }, 40);
        });
      });
    }, { threshold: 0.3 });
    cio.observe(sg);
  }

  /* ---------- PDP: gallery + tiers ---------- */
  var mainImg = $("#pdp-main-img");
  $$(".pdp-thumb").forEach(function (t) {
    t.addEventListener("click", function () {
      if (!mainImg) return;
      var src = t.getAttribute("data-src");
      if (src) mainImg.src = src;
      $$(".pdp-thumb").forEach(function (x) { x.classList.remove("on"); });
      t.classList.add("on");
    });
  });

  var vinput = $("#pdp-variant"), totalEl = $("#pdp-total");
  $$(".pdp2-tier").forEach(function (tier) {
    tier.addEventListener("click", function () {
      $$(".pdp2-tier").forEach(function (x) { x.classList.remove("on"); });
      tier.classList.add("on");
      if (vinput) vinput.value = tier.getAttribute("data-vid");
      if (totalEl) totalEl.textContent = tier.getAttribute("data-price");
      var pr = $("#pdp-price-cur"), cmp = $("#pdp-price-cmp"), sv = $("#pdp-save");
      if (pr) pr.textContent = tier.getAttribute("data-price");
      if (cmp) cmp.textContent = tier.getAttribute("data-compare");
      if (sv) sv.textContent = "SAVE " + tier.getAttribute("data-save") + "%";
    });
  });

  /* ---------- Index: pack select syncs price ---------- */
  var lsel = $("#landing-select"), lprice = $("#landing-price");
  if (lsel && lprice) {
    lsel.addEventListener("change", function () {
      var o = lsel.options[lsel.selectedIndex];
      var p = o.getAttribute("data-price");
      if (p) lprice.textContent = p;
    });
  }
})();
